import React from "react";
export default function getInitials(name) {
  var [firstName, lastName] = name.split(" ");
  return firstName && lastName ? "".concat(firstName.charAt(0)).concat(lastName.charAt(0)) : firstName.charAt(0);
}
export var Avatar = _ref => {
  var {
    name,
    src
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "rnf-avatar"
  }, src ? /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: "Image of ".concat(name),
    className: "rnf-avatar__image"
  }) : /*#__PURE__*/React.createElement("span", {
    className: "rnf-avatar__initials"
  }, getInitials(name)));
};
//# sourceMappingURL=Avatar.js.map